export enum MaturePassengerSessionStorageKeys {
    originalTypeCode = 'originalTypeCode',
    scheduledTypeCodeChange = 'scheduledTypeCodeChange',
    psoWorkAgreement = 'psoWorkAgreement',
    psoFamilyAgreement = 'psoFamilyAgreement',
}